<template>

    <v-container justify-start>

<!-- balance -->
        <balancebox/>

<!-- project cards -->

      <v-layout row wrap mt-5 align-center justify-center>
       <v-flex xs12>
          <h2>Проекты для инвестиций</h2>
       </v-flex>

        <v-flex xs12 md4 v-for="(project, index) in Projects" v-bind:key="project.id">
          <v-card class="elevation-1 cardProject">
            <v-card-title>
                <router-link :to="{name:'Проект', params:{id:project.id}}" text-right>{{project.name}}</router-link>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>Объем закупки (т.):</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ project.quantity }} из {{project.maxQuantity}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Сумма закупки:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ project.sum }} из {{project.maxSum}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Дата закупки:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ project.dateStart }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Ожидаемая прибыль (%):</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{project.profitExpected}}</v-list-tile-content>
                </v-list-tile>

            </v-list>

            <v-card-actions pa-3>
              <v-btn color="success" @click="invest(project.id)">Инвестировать</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

<!-- user projects -->
<!-- TODO1 фильтр своих проектов  по статусам-->

      <v-layout row wrap mt-5>
         <v-flex xs12>
          <h2>Мои инвестиции</h2>
         </v-flex>
         <v-flex xs12 class="elevation-1">
            <v-data-table
              :headers="headers"
              :items="myProjects"
              hide-actions
              item-key="name">
              <template v-slot:items="props" >
                <td>{{ props.item.num }}</td>
                <td>{{ props.item.status }}</td>
                <td @click="clickProject(props.item)" ><a>{{ props.item.name }}</a></td>
                <td class="text-xs-right">{{ props.item.sumMy }}</td>
                <td class="text-xs-right">{{ props.item.profit }}</td>
              </template>
            </v-data-table>
        </v-flex>
      </v-layout>

<!-- spiner -->
      <v-layout row class="overlay" v-if="!ready">
          <div class="flex-spinner">
            <v-progress-circular :size="200" :width="7" indeterminate color="amber"></v-progress-circular>
          </div>
      </v-layout>
    </v-container>
</template>

<script>
import BalanceBox from "./partials/BalanceBox"

export default {
   components:{
    balancebox:BalanceBox
  },
    created () {
      this.ready = true
      //this.$store.dispatch('projects/fetchProjects').then(()=>{this.ready = true})
    },
    mounted () {
    },
    computed: {
      Projects() {
       return this.$store.getters['projects/projectsByStatus']('открыт')
     },
      myProjects() {//TODO мои проекты по статусам
       return this.$store.getters['projects/myProjects']
     }
    },
    data () {
        return {
            ready: false,
            elems:[{name:'1',quantity:1}],
            headers: [
             { text: '№',
              align: 'left',
              sortable: false,
              value: 'name' },
             { text: 'Статус',
              align: 'left',
              value: 'status' },
             { text: 'Проект',
              align: 'left',
              sortable: false,
              value: 'name' },
             { text: 'Сумма',
              align: 'right',
              value: 'sumMy' },
             { text: 'Профит',
              align: 'right',
              value: 'profit' }
              ]
        }
    },
    methods: {
      invest(id) {
        console.log('invest',id);
        this.$router.push({name:'Проект', params:{id:id}})
      },
      clickProject(item) {
        console.log('click',item.num);
        this.$router.push({name:'Проект', params:{id:item.id}})
      }
    }
}
</script>

<style scoped>
    .cardProject {
      margin: 5px 5px 5px 5px;
    }
</style>



// WEBPACK FOOTER //
// ProjectsList.vue?32c25f66